export const DEBT_COLLECTION_DELAY_MIN_COMPANY_DAYS = 7
export const DEBT_COLLECTION_DELAY_MIN_PERSON_DAYS = 14
export const DEBT_COLLECTION_DELAY_MAX_DAYS = 90
